const e = "_parenthesisCellRoot_x10l2_1", t = "_alignLeft_x10l2_14", l = "_alignCenter_x10l2_17", n = {
  parenthesisCellRoot: e,
  alignLeft: t,
  alignCenter: l
};
export {
  l as alignCenter,
  t as alignLeft,
  n as default,
  e as parenthesisCellRoot
};
//# sourceMappingURL=index.es733.js.map
